import { atom } from "jotai";
import { Node } from "@xyflow/react";
import {
  nodesAtom,
  edgesAtom,
  emitAiPredictionUserFeedbackEventSetter,
  canvasAtom,
  nodeAtomFamily,
  SuggestedNodeData,
} from "../index";
import { NOT_HELPFUL } from "@zapier/canvas-constants";
import { createHash } from "crypto";

export const removeSuggestedNodeAndEdgesSetter = atom(
  null,
  (get, set, nodeId: string) => {
    const canvas = get(canvasAtom);
    const suggestedNode = get(
      nodeAtomFamily(nodeId),
    ) as Node<SuggestedNodeData>;
    if (!suggestedNode) {
      throw new Error("Suggested node not found");
    }
    // Emit the rejection event before removing the node
    set(emitAiPredictionUserFeedbackEventSetter, {
      prediction_id: createHash("sha256")
        .update(JSON.stringify(suggestedNode.data.zsl))
        .digest("hex"),
      user_rating: NOT_HELPFUL,
      user_feedback: "rejected",
      correlation_id: canvas.id,
    });

    set(nodesAtom, (nodes) => nodes.filter((node) => node.id !== nodeId));
    set(edgesAtom, (edges) =>
      edges.filter((edge) => edge.source !== nodeId && edge.target !== nodeId),
    );
  },
);

removeSuggestedNodeAndEdgesSetter.debugLabel =
  "removeSuggestedNodeAndEdgesSetter";
